
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';


// Initalize and export Firebase.
const config = {
				apiKey: "AIzaSyDT20zRQHaVwtUkgOROvkLApfD3Ro5SkNQ",
				authDomain: "burnside-train.firebaseapp.com",
				databaseURL: "https://burnside-train.firebaseio.com",
				projectId: "burnside-train",
				storageBucket: "",
				messagingSenderId: "1030414219365",
				appId: "1:1030414219365:web:46c89526b4f65806"
};
export default firebase.initializeApp(config);


// WEBPACK FOOTER //
// ./src/firebase.js